import React from 'react';
import { connect } from 'react-redux';
import { logout } from '../../auth/actions/authActions';

const ErrorMessage = (props) => {
  const errorCodes = {
    100: "Could not retrieve survey questions.",
    101: "Could not submit survey responses.",
    102: "Could not retrieve FSP Profile.",
    103: "Could not retrieve Merchant Profile",
    104: "No registrations could be found for the given mobile number",
    105: "Could not retrieve Merchant Trading Hours",
    106: "Could not save Merchant Trading Hours",
    107: "Could not load merchants for the given mobile number"
  };

  return (
    <span>
      <p>{props.message}</p>
      <p>
        <b>{props.errorCode ? errorCodes[props.errorCode] : props.referenceNumber}</b>
      </p>
    </span>
  );
};

class ContactUs extends React.Component {
  render() {
    let hrefText = "tel:".concat(this.props.core.serviceDeskContactNumber);
    let { mode, referenceNumber } = this.props.routeParams;
    let messageComponent = null;

    switch (mode) {
      case "incorrectdetails":
        messageComponent = <ErrorMessage message="Give us a call and quote the reference number below." referenceNumber={referenceNumber} />;
        break;
      case "autoLoginError":
        messageComponent = <ErrorMessage message="Failed to log you in. Give us a call! " />;
        break;
      case "error":
        messageComponent = <ErrorMessage message="Hmmm, something is not right. Give us a call and quote the reference below." referenceNumber={referenceNumber} />;
        break;
      case "errorDetailed":
        messageComponent = <ErrorMessage message="An error occurred." errorCode={referenceNumber} />;
        break;
      case "rebook":
        messageComponent = <ErrorMessage message="To rebook this job, please give us a call and quote the reference number below." referenceNumber={referenceNumber} />;
        break;
      default:
        messageComponent = <ErrorMessage message="Give us a call!" />;
        break;
    }

    return (
      <div>
        <div className="jumbotron text-center">
          <h1>Contact Us</h1>
          <div>{messageComponent}</div>
          <p>
            <a className="btn btn-client btn-lg" href={hrefText} role="button">
              <i className="fa fa-phone" /> {this.props.core.serviceDeskContactNumber}
            </a>
          </p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    booking: state.booking,
    core: state.core
  };
}

function mapDispatchToProps(dispatch) {
  return {

    logout: () => {
      dispatch(logout());
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);


// WEBPACK FOOTER //
// ./app/core/components/contactUs.js